function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import amplitude from 'amplitude-js';
import { CareAmpli, DEFAULT_AMPLI_INSTANCE_NAME } from './ampli-variant';
var amplitudeInstance;
var analyticsConfig;
var tempEventsBuffer = [];
var tempUserPropsBuffer = [];
export function logEvent(payload) {
  var combinedAttributes;
  var status;

  if (!payload || !payload.name) {
    throw new Error('CareAnalytics: Invalid event payload');
  }

  if (amplitudeInstance && analyticsConfig.analyticsEnabled) {
    var eventData = payload.data ? payload.data : {};
    analyticsConfig.commonData = analyticsConfig.commonData ? analyticsConfig.commonData : {};
    combinedAttributes = _objectSpread(_objectSpread({
      url: document.location.href,
      url_path: document.location.pathname
    }, analyticsConfig.commonData), eventData);
    amplitudeInstance.logEvent(payload.name, combinedAttributes);
    status = 'CareAnalytics: Event logged';
  } else {
    tempEventsBuffer.push(payload);
    status = 'CareAnalytics: Event buffered';
  }

  return status;
}
export var setUserProps = function setUserProps(user) {
  var status;

  if (!amplitudeInstance) {
    tempUserPropsBuffer.push(user);
    status = 'CareAnalytics: Properties can only be set after Amplitude is initialized';
  } else {
    if (user.memberId) {
      amplitudeInstance.setUserId(user.memberId);
    }

    if (user.props) {
      amplitudeInstance.setUserProperties(user.props);
    }

    status = 'CareAnalytics: User properties set successfully';
  }

  return status;
};
export var init = function init(config) {
  var status;

  if (!config) {
    throw new Error('CareAnalytics: Missing config');
  } else if (config.analyticsEnabled === false) {
    status = 'CareAnalytics: Analytics disabled';
  } else if (!config.key) {
    throw new Error('CareAnalytics: Missing Analytics key');
  } else if (!amplitudeInstance) {
    var _analyticsConfig;

    amplitudeInstance = amplitude.getInstance();
    amplitudeInstance.init(config.key);

    if (config.user) {
      setUserProps(config.user);
    }

    analyticsConfig = _objectSpread(_objectSpread({}, config), {}, {
      commonData: _objectSpread(_objectSpread({}, ((_analyticsConfig = analyticsConfig) === null || _analyticsConfig === void 0 ? void 0 : _analyticsConfig.commonData) || {}), config.commonData)
    });
    status = 'CareAnalytics: initialization successful';

    if (tempUserPropsBuffer.length) {
      tempUserPropsBuffer.forEach(function (user) {
        return setUserProps(user);
      });
    }

    if (tempEventsBuffer.length) {
      tempEventsBuffer.forEach(function (payload) {
        return logEvent(payload);
      });
    }
  }

  return status;
};
export var updateCommonData = function updateCommonData(data) {
  analyticsConfig = analyticsConfig || {
    key: ''
  };
  analyticsConfig.commonData = _objectSpread(_objectSpread({}, analyticsConfig.commonData || {}), data);
  return _objectSpread({}, analyticsConfig.commonData);
};
export var getInstance = function getInstance() {
  return amplitudeInstance;
};
export { CareAmpli, DEFAULT_AMPLI_INSTANCE_NAME };
//# sourceMappingURL=index.js.map